import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CastecategoryListComponent } from './castecategory-list/castecategory-list.component';
import { CastecategoryCreateComponent } from './castecategory-create/castecategory-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list',
        component: CastecategoryListComponent,
        data: {
          title: "Caste Category List",
          breadcrumb: "Caste Category List"
        }
      },
      {
        path: 'create',
        component: CastecategoryCreateComponent,
        data: {
          title: "Create Caste Category",
          breadcrumb: "Create Caste Category"
        }
      },
      {
        path: 'edit/:id',
        component: CastecategoryCreateComponent,
        data: {
          title: "Edit Caste Category",
          breadcrumb: "Edit Caste Category"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class CastecategoryRoutingModule { }
